import { useEffect, useRef } from "react"
import consumer from "channels/consumer"

export const JOB_SERVICES_LIST_BROADCAST = "job-services-list-updates"

export const applyJobServiceListUrgencyUpdate = (grouped, payload) => {
  if (!grouped || payload?.id == null) return grouped

  const targetId = String(payload.id)
  let changed = false
  const next = {}

  Object.keys(grouped).forEach(key => {
    const rows = grouped[key]
    if (!Array.isArray(rows)) {
      next[key] = rows
      return
    }

    next[key] = rows.map(row => {
      if (String(row.id) !== targetId) return row
      changed = true
      const nextAttributes = { ...row.attributes }
      if (payload.project_urgency !== undefined) {
        nextAttributes.project_urgency = payload.project_urgency
      }
      if (payload.client_due_date !== undefined) {
        nextAttributes.client_due_date = payload.client_due_date
      }
      if (payload.client_due_date_overdue !== undefined) {
        nextAttributes.client_due_date_overdue = payload.client_due_date_overdue
      }
      return {
        ...row,
        attributes: nextAttributes
      }
    })
  })

  return changed ? next : grouped
}

export const publishJobServiceListUpdate = payload => {
  if (typeof BroadcastChannel === "undefined" || !payload) return
  const channel = new BroadcastChannel(JOB_SERVICES_LIST_BROADCAST)
  channel.postMessage(payload)
  channel.close()
}

const useJobServicesListRealtime = ({ onUpdate, onVisible }) => {
  const onUpdateRef = useRef(onUpdate)
  const onVisibleRef = useRef(onVisible)
  onUpdateRef.current = onUpdate
  onVisibleRef.current = onVisible

  useEffect(() => {
    const subscription = consumer.subscriptions.create(
      { channel: "JobServicesListChannel" },
      {
        received(data) {
          if (onUpdateRef.current) onUpdateRef.current(data)
        }
      }
    )

    return () => subscription.unsubscribe()
  }, [])

  useEffect(() => {
    if (typeof BroadcastChannel === "undefined") return undefined

    const channel = new BroadcastChannel(JOB_SERVICES_LIST_BROADCAST)
    channel.onmessage = event => {
      if (onUpdateRef.current) onUpdateRef.current(event.data)
    }

    return () => channel.close()
  }, [])

  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible" && onVisibleRef.current) onVisibleRef.current()
    }

    document.addEventListener("visibilitychange", onVisibilityChange)
    return () => document.removeEventListener("visibilitychange", onVisibilityChange)
  }, [])
}

export default useJobServicesListRealtime
